"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var helpers_1 = require("../../../helpers");
var adPlacements_1 = require("../config/adPlacements");
var getPlacementDetails_1 = require("../utils/getPlacementDetails");
var getAdTypes_1 = __importDefault(require("../utils/getAdTypes"));
var getPlacementFromAdUnitId_1 = __importDefault(require("../utils/getPlacementFromAdUnitId"));
var getPlacementSizes_1 = require("../utils/getPlacementSizes");
var getAdzerkTargeting_1 = __importDefault(require("../utils/targeting/getAdzerkTargeting"));
var loadKevel_1 = __importDefault(require("./loadKevel"));
var loadHbAdPrebid_1 = __importDefault(require("./loadHbAdPrebid"));
var loadAFPAd_1 = __importDefault(require("./loadAFPAd"));
var getSiteId = function (placementName) {
    return placementName === adPlacements_1.adPlacements.MREC_TOP ? 421790 : 1025452;
};
/**
 * run an auction for an adUnitId
 */
function runAuction(adUnitId, testGroups, adContext, userGeo, userDeviceType) {
    var _a, _b, _c, _d, _e, _f;
    (0, helpers_1.getCookie)("debug-ads") && console.log("".concat(adUnitId, ": running auction"));
    // setup placements object
    var placementsObj = {
        placements: {},
    };
    // remove timestamp from placementName
    var placementName = (0, getPlacementFromAdUnitId_1.default)(adUnitId);
    var placementSizes = (0, getPlacementSizes_1.getPlacementSizes)(placementName);
    var placementDetails = (placementsObj.placements[adUnitId] =
        (0, getPlacementDetails_1.getPlacementDetails)(placementName));
    // some story details and story reading specific capture stuff removed
    var typesArray = placementSizes ? (0, getAdTypes_1.default)(placementSizes) : [];
    // Construct MVP Adzerk parameters
    var adzerkPlacementMeta = {
        siteId: getSiteId(placementName),
        networkId: 9660,
        adTypes: typesArray,
        targeting: (0, getAdzerkTargeting_1.default)(adContext === null || adContext === void 0 ? void 0 : adContext.story, adContext === null || adContext === void 0 ? void 0 : adContext.storyPart, adContext === null || adContext === void 0 ? void 0 : adContext.user),
    };
    (0, lodash_merge_1.default)(placementsObj.placements[adUnitId], adzerkPlacementMeta);
    var clientId;
    // detecting if the author of the story is onboarded into AFP per client
    if (testGroups.USE_AFP && ((_b = (_a = adContext === null || adContext === void 0 ? void 0 : adContext.story) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.afpClientId)) {
        clientId = (_d = (_c = adContext === null || adContext === void 0 ? void 0 : adContext.story) === null || _c === void 0 ? void 0 : _c.user) === null || _d === void 0 ? void 0 : _d.afpClientId;
        (0, helpers_1.getCookie)("debug-ads") &&
            console.log("".concat(adUnitId, ": using afp clientId from server: ").concat(clientId));
    }
    else if (testGroups.USE_AFP && !((_f = (_e = adContext === null || adContext === void 0 ? void 0 : adContext.story) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f.afpClientId)) {
        (0, helpers_1.getCookie)("debug-ads") &&
            console.log("".concat(adUnitId, ": clientId from server not found"));
    }
    else {
        (0, helpers_1.getCookie)("debug-ads") &&
            console.log("".concat(adUnitId, ": not looking up afp clientId"));
    }
    if (testGroups.USE_AFP && clientId) {
        (0, helpers_1.getCookie)("debug-ads") && console.debug("".concat(adUnitId, ": running afp ad."));
        (0, loadAFPAd_1.default)(adUnitId, clientId);
    }
    else if (placementDetails === null || placementDetails === void 0 ? void 0 : placementDetails.adzerkOnly) {
        (0, helpers_1.getCookie)("debug-ads") &&
            console.debug("".concat(adUnitId, ": only loading kevel to run auction."));
        var placementOpts = placementsObj && placementsObj.placements;
        var innerPlacement = placementOpts[adUnitId];
        var properties = innerPlacement === null || innerPlacement === void 0 ? void 0 : innerPlacement.targeting;
        // only myworks ad for now;
        (0, loadKevel_1.default)({
            adUnitId: adUnitId,
            innerPlacement: innerPlacement,
            properties: properties,
            kevelOnly: true,
        });
    }
    else {
        (0, helpers_1.getCookie)("debug-ads") &&
            console.debug("".concat(adUnitId, ": loading prebid to run auction."));
        (0, loadHbAdPrebid_1.default)(placementsObj, testGroups, userGeo, userDeviceType);
    }
}
exports.default = runAuction;
